// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"726b1acc","248":"48b539cc","407":"726b1acc","417":"fc181b20","434":"726b1acc","508":"6188efbf","522":"065a50b1","595":"726b1acc","726":"48b539cc","756":"48b539cc","829":"a2f2d172","873":"c11d474d","922":"726b1acc"}[chunkId] + ".chunk.css";
};